// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"170":"27bb1206","8648":"27bb1206"}[chunkId] + ".chunk.css";
};